// Dialog Header
type DialogHeaderProps = {
  children: React.ReactNode;
  className?: string;
};

export function DialogHeader({ children, className = "" }: DialogHeaderProps) {
  return (
    <div className={`px-6 py-4 shadow sticky top-0 bg-white z-10 ${className}`}>
      {children}
    </div>
  );
}
